import { fromJS, List, Map } from 'immutable'
import { propOr } from 'ramda'
import {
  CTPM_PREP_DATA,
  CTPM_SHOW_CTP_MAPPING_MODAL,
  CPTM_SET_ASSIGNMENTS,
  CPTM_STAGE_ASSIGNMENTS,
  CTPM_CLEAN_UP,
  CTPM_CLEAN_UP_ON_SAVE,
} from 'actions/ctpMappingWorkflow'
import { createReducer } from './utils'

const initialState = fromJS({
  ctpMappingModal: {
    visible: false,
  },
  circuits: [],
  selectedRP: {},
  assignments: [],
  stagedAssignments: [],
  serialNumber: '',
})

const handlers = {
  [CTPM_PREP_DATA]: setData,
  [CTPM_SHOW_CTP_MAPPING_MODAL]: showWorkflowModal,
  [CPTM_STAGE_ASSIGNMENTS]: setCtpStagedAssignments,
  [CPTM_SET_ASSIGNMENTS]: setCtpAssignments,
  [CTPM_CLEAN_UP]: cleanUpMappingData,
  [CTPM_CLEAN_UP_ON_SAVE]: cleanupOnSave,
}

export default createReducer(initialState, handlers)

function cleanupOnSave(state) {
  return state.merge(
    fromJS({
      serialNumber: '',
      circuits: List(),
      selectedRP: Map(),
    })
  )
}

function cleanUpMappingData(state, { payload }) {
  return state.merge({
    serialNumber: '',
    circuits: List(),
    selectedRP: Map(),
    stagedAssignments: List(),
    assignments: fromJS(propOr([], 'assignments', payload)),
  })
}

function setData(
  state,
  {
    payload: {
      serialNumber,
      circuits,
      selectedRP,
      assignments,
      stagedAssignments,
    },
  }
) {
  return state.merge(
    fromJS({
      serialNumber,
      circuits,
      selectedRP,
      assignments,
      stagedAssignments,
    })
  )
}

function showWorkflowModal(state, { payload: { visible } }) {
  return state.setIn(['ctpMappingModal', 'visible'], visible)
}

function setCtpAssignments(state, { payload: { assignments } }) {
  return state.set('assignments', fromJS(assignments))
}

function setCtpStagedAssignments(state, { payload: { stagedAssignments } }) {
  return state.set('stagedAssignments', fromJS(stagedAssignments))
}
